<template>
    <div id='ReceiptCreateForm' class='row'>
        <BoxSideMenu
            :navSteps='steps'
            :activeStep='activeStepIdx'
        />
        <div class='col-9 FormContent' :key='resetIdx'>
            <div class=' CardName row'>
                <h4>{{activeTitle}}</h4>
            </div>
            <div v-if="this.activeStepName === 'vendor'" class='row' >
                <div class='col-12' >
                    <div class='SectionTitle row'>
                        <h5>{{this.steps[this.activeStepName].formHeader}}</h5>
                    </div>
                    <div class='row'>
                        <div class='col-12'>
                            <TextBox
                            label="Vendor Invoice Number"
                            store="BuyTracker/ReceiptCreate"
                            name='vendorInvoiceNum'
                            placeholder='Form Input'
                            :hasErrors='showErrors == false ? false : !validationGroups.vendor[0].valid'
                            :validationRules="['required']"
                            @validate-field='updateStepValidation'
                        />
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-6 SelectBox'>
                            <Select
                                label='Buyer'
                                store="BuyTracker/ReceiptCreate"
                                name='buyer'
                                :options='buyerOptions'
                                :hasErrors='showErrors == false ? false : !validationGroups.vendor[1].valid'
                                :validationRules="['required']"
                                @validate-field='updateStepValidation'
                            />
                        </div>
                        <div class='col-6 SelectBox'>
                            <Select
                                label='Vendor'
                                store="BuyTracker/ReceiptCreate"
                                name='vendor'
                                :options='vendorOptions'
                                :hasErrors='showErrors == false ? false : !validationGroups.vendor[2].valid'
                                :validationRules="['required']"
                                @validate-field='updateStepValidation'
                            />
                        </div>
                        
                    </div>
                    <div class='row'>
                        <div class='col-6 SelectBox'>
                            <Select
                                label='Buy Team'
                                store="BuyTracker/ReceiptCreate"
                                name='buyTeam'
                                :options='buyTeamOptions'
                                :hasErrors='showErrors == false ? false : !validationGroups.vendor[3].valid'
                                :validationRules="['required']"
                                @validate-field='updateStepValidation'
                            />
                        </div>
                        <div class='col-6 SelectBox'>
                            <Select
                                label='Vendor Location'
                                store="BuyTracker/ReceiptCreate"
                                name='vendorLocation'
                                :options='vendorLocationOptions'
                                :hasErrors='showErrors == false ? false : !validationGroups.vendor[4].valid'
                                :validationRules="['required']"
                                @validate-field='updateStepValidation'
                            />
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-6 SelectBox'>
                            <Select
                                label='Currency'
                                store="BuyTracker/ReceiptCreate"
                                name='currency'
                                :options='currencyOptions'
                                :hasErrors='showErrors == false ? false : !validationGroups.vendor[5].valid'
                                :validationRules="['required']"
                                @validate-field='updateStepValidation'
                            />
                        </div>
                        <div class='col-6'>
                            <CurrencyInput
                                label='Invoice Total ($)'
                                store="BuyTracker/ReceiptCreate"
                                name='invoiceTotal'
                                :hasErrors='showErrors == false ? false : !validationGroups.vendor[6].valid'
                                :validationRules="['required']"
                                @validate-field='updateStepValidation'
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="this.activeStepName === 'segment'" class='row Segment'>
                <div class='col-12'>
                    <div class='SectionTitle row'>
                        <h5>{{this.steps[this.activeStepName].formHeader}}</h5>
                    </div>
                    <div class='row'>
                        <div class='col-6 SelectBox'>
                            <Select
                                label='Brand'
                                store="BuyTracker/ReceiptCreate"
                                name='brand'
                                :options='brandOptions'
                                :hasErrors='showErrors == false ? false : !validationGroups.segment[0].valid'
                                :validationRules="['required']"
                                @validate-field='updateStepValidation'
                            />
                        </div>
                        <div class='col-6 SelectBox'>
                            <Select
                                label='Category'
                                store="BuyTracker/ReceiptCreate"
                                name='category'
                                :hasErrors='showErrors == false ? false : !validationGroups.segment[1].valid'
                                :options='categoryOptions'
                                :validationRules="['required']"
                                @validate-field='updateStepValidation'
                            />
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-6 SelectBox'>
                            <Select
                                label='Segment'
                                store="BuyTracker/ReceiptCreate"
                                name='segment'
                                :hasErrors='showErrors == false ? false : !validationGroups.segment[2].valid'
                                :options='segmentOptions'
                                :validationRules="['required']"
                                @validate-field='updateStepValidation'
                            />
                        </div>
                        <div class='col-6'>
                            <TextBox
                                label="Quantity"
                                store="BuyTracker/ReceiptCreate"
                                name='quantity'
                                placeholder='Enter Style Number'
                                :hasErrors='showErrors == false ? false : !validationGroups.segment[3].valid'
                                :validationRules="['required', 'number']"
                                @validate-field='updateStepValidation'
                            />
                        </div>
                    </div>
                    <div class='row AddReciept'>
                        <div class='col-5 Spacer'>&nbsp;</div>
                        <div class='col-2 AddToReceipt'>
                            <Button 
                                CTA='Add To Receipt'
                                type='primary'
                                btnClass='BtnAdd'
                                btnAction='AddToReceipt'
                                btnTarget='addto-receipt'
                                @addto-receipt='addtoReceipt'
                            />
                        </div>
                        <div class='col-5 Spacer'>&nbsp;</div>
                    </div>
                    <div class='row TableTop'>
                        <ItemTable 
                            classes='table-striped caption-top col-12'
                            :headers='receiptItems.headers'
                            :items='receiptItems.items'
                            caption='Items on Receipt'
                        />
                    </div>
                </div>
            </div>
            <div v-if="this.activeStepName === 'tender'" class='row'>
                <div class='col-12'>
                    <div class='SectionTitle row'>
                        <h5>{{this.steps[this.activeStepName].formHeader}}</h5>
                    </div>
                    <div class='row'>
                        <div class='col-6 SelectBox'>
                            <Select
                                label='How did you pay for this?'
                                store="BuyTracker/ReceiptCreate"
                                name='tender'
                                :options='tenderOptions'
                                :hasErrors='showErrors == false ? false : !validationGroups.tender[0].valid'
                                :validationRules="['required']"
                                @validate-field='updateStepValidation'
                            />
                        </div>
                    </div>
                    
                    <div class='row'>
                        <div class='col-6'>
                            <CurrencyInput
                                label='How much did you spend with this tender?'
                                store="BuyTracker/ReceiptCreate"
                                name='tenderTotal'
                                :hasErrors='showErrors == false ? false : !validationGroups.tender[1].valid'
                                :validationRules="['required']"
                                @validate-field='updateStepValidation'
                            />
                        </div>
                        <div class='col-6'>
                            <DateInput
                                label="Date Purchased"
                                store="BuyTracker/ReceiptCreate"
                                name='purchaseDate'
                                :hasErrors='showErrors == false ? false : !validationGroups.tender[2].valid'
                                :validationRules="['required']"
                                placeholder='Enter Date Purchased'
                                @validate-field='updateStepValidation'
                                
                            />
                        </div>
                    </div>
                    <div class='row AddTender'>
                        <div class='col-4 Spacer'>&nbsp;</div>
                        <div class='col-4 AddTenderType'>
                            <Button 
                                CTA='Add Tender Type'
                                type='primary'
                                btnClass='BtnAdd'
                                btnAction='AddTenderType'
                                btnTarget='add-tendertype'
                                @addto-tendertype='addTendertype'
                            />
                        </div>
                        <div class='col-4 Spacer'>&nbsp;</div>
                    </div>
                    <div class='row TableTop TenderTypeTable'>
                        <ItemTable 
                            classes='table-striped caption-top col-12'
                            :headers='tenderTypes.headers'
                            :items='tenderTypes.items'
                            caption='Tender Types'
                        />
                    </div>
                </div>
            </div>
            <div v-if="this.activeStepName === 'summary'" class='row Summary'>
                <div class='col-12'>
                    <div class='row TableTop'>
                        <h4 class='col-12 TableTitle'>Items on Receipt</h4>
                    </div>
                    <div class='row'>
                         <ItemTable 
                            classes='table-striped caption-top col-12'
                            :headers='receiptItems.headers'
                            :items='receiptItems.items'
                            caption='Items on Receipt'
                        />
                    </div>
                    <div class='row TableTop'>
                        <h4 class='col-12 TableTitle'>Tender Types on Receipt</h4>
                    </div>
                    <div class='row TenderTypeTable'>
                        <ItemTable 
                            classes='table-striped caption-top col-12'
                            :headers='tenderTypes.headers'
                            :items='tenderTypes.items'
                            caption='Tender Types'
                        />
                    </div>
                    <div class='row BoxAddSection'>
                        <div class='col-6 AddItemToBox'>
                            <Select
                                label='Add Receipt To Box'
                                store="BuyTracker/ReceiptCreate"
                                name='selectedBox'
                                :options='boxOptions'
                                :disabled='false'
                                
                            />
                        </div>
                        <div class='col-2 AddToBox'>
                            <Button 
                                CTA='Add To Box'
                                type='primary'
                                btnClass='BtnAdd'
                                btnAction='AddToBox'
                                btnTarget='addto-box'
                                @addto-box='addtoBox'
                            />
                        </div>
                        <div class='or col-1'><span>OR</span></div>
                        <div class='col-3 CreateBox'>
                            <Button 
                                btnAction='link'
                                btnTarget='/buy-tracker/box-create'
                                CTA='Create New Box'
                                type='primary'
                                btnClass='BtnCreate'
                            />
                        </div>
                    </div>
                    <div class='row CompleteItemCreate'>
                        <div class='col-4 Spacer'>&nbsp;
                        </div>
                        <div class='col-4'>
                            <Button 
                                CTA='Save Receipt'
                                btnClass='BtnSave'
                                :disabled='formErrors'
                                btnAction='SaveReceipt'
                                btnTarget='save-receipt'
                                @save-receipt='saveReceipt'
                            />
                        </div>
                        <div class='col-4 Spacer'>&nbsp;
                        </div>
                    </div>
                </div>
            </div>
            <div class='row PageFooter'>
                <div class='col-12 text-center'>
                    <DotNav
                        :steps='steps'
                        @update-nav="updateNav"
                    />
                </div>
            </div>
        </div>
    </div>


</template>

<script>
    import BoxSideMenu from '../Nav/BoxSideMenu';
    import DotNav from '../Nav/DotNav';
    import Select from '../../../core/form/Select.vue';
    import DateInput from '../../../core/form/DateInput.vue';
    import CurrencyInput from '../../../core/form/CurrencyInput.vue';
    import TextBox from '../../../core/form/TextBox.vue';
    import SelectMultiArrows from '../../../core/form/SelectMultiArrows.vue';
    import DisplayIcon from '../../../icons/DisplayIcon';
    import ImageUpload from '../../../core/form/ImageUpload.vue';
    import Button from '../../../core/form/Button.vue';
    import ItemTable from './ListTable';
    export default{
            name: 'ReceiptCreateForm',
            components: {
                BoxSideMenu,
                Select,
                CurrencyInput,
                DateInput,
                DotNav,
                DisplayIcon,
                TextBox,
                SelectMultiArrows,
                ImageUpload,
                Button,
                ItemTable
            },
            data() {
                return {
                    resetIdx: 0,
                    showErrors: false,
                    steps: {
                        vendor: {
                            order: 0,
                            title: 'Where did you buy it?',
                            subtitle: 'Vendor Information',
                            formHeader: 'Receipt Information',
                            errors: true,
                            completed: false,
                            active: true
                        },
                        segment: {
                            order: 1,
                            title: 'What did you buy?',
                            subtitle: 'Item/Segment counts',
                            formHeader: 'Add Item to receipt',
                            errors: false,
                            completed: false,
                            active: false
                        },
                        tender: {
                            order: 2,
                            title: 'How did you pay for it?',
                            subtitle: 'Tender Types',
                            formHeader: 'Add Tender Types to Receipt',
                            completed: false,
                            active: false,
                            errors: false
                        },
                        summary: {
                            order: 3,
                            title: 'Summary',
                            subtitle: 'Review and Confirm',
                            completed: false,
                            active: false,
                            errors: false
                        }
                    },
                    
                    currentItemCreation:[],
                    receiptOptions: [],
                    subcategoryOptions: [],
                    buyTeamOptions: [],
                    buyerOptions: [],
                    vendorOptions: [],
                    vendorLocationOptions: [],
                    currencyOptions: [],
                    brandOptions: [],
                    categoryOptions: [],
                    segmentOptions: [],
                    tenderOptions: [],
                    boxOptions: [],
                    receiptItems: {},
                    tenderTypes: {},

                    receiptValidationGroups:{
                        vendor: [
                            {name: 'vendorInvoiceNum', valid: false},
                            {name: 'buyer', valid: false},
                            {name: 'vendor', valid: false},
                            {name: 'buyTeam', valid: false},
                            {name: 'vendorLocation', valid: false},
                            {name: 'currency', valid: false},
                            {name: 'invoiceTotal', valid: false}
                        ],
                        segment: [
                            {name: 'brand', valid: false},
                            {name: 'category', valid: false},
                            {name: 'segment', valid: false},
                            {name: 'quantity', valid: false}
                        ],
                        tender: [
                            {name: 'tender', valid: false},
                            {name: 'tenderTotal', valid: false},
                            {name: 'purchaseDate', valid: false}
                        ],
                        summary: []
                    },
                    currentForm: {'name' : 'New Receipt', 'route': '/buy-tracker/receipt-create'}
            }},
            computed: {
                activeStepName() {
                    var match = null;
                    for (const [key, value] of Object.entries(this.steps)) {
                        if(value.active == true) {
                            match = key;
                        }
                    }
                    return match;
                },
                activeStepIdx: {
                    get(){
                        var match = this.$store.getters['BuyTracker/ReceiptCreate/currentPage'] || 0;
                        for (const [key, value] of Object.entries(this.steps)) {
                            if(value.order < match){
                                value.completed = (Object.values(this.validationGroups[key]).findIndex(x => x.valid == false) == -1) ? true : false;
                                value.errors = !value.completed;
                            }
                            value.active = (value.order == match) ? true : false
                        }
                        return match;
                    },
                    set(value){
                        return this.$store.dispatch('BuyTracker/ReceiptCreate/set', {field: 'currentPage', value}) 
                    }
                },
                activeTitle(){return this.activeStepIdx == 3 ? 'Summary' : 'Create a Receipt'},
                itemName() {
                    return this.$store.getters['BuyTracker/ReceiptCreate/productName']
                },
                itemSku(){
                    return this.$store.getters['BuyTracker/ReceiptCreate/productSku']
                },
                validationGroups:{
                    get () { return this.$store.getters['BuyTracker/ReceiptCreate/validationGroups']},
                    set (value) { return this.$store.dispatch('BuyTracker/ReceiptCreate/set', {field: 'validationGroups', value}) },
                },
                formErrors(){
                    let foundErrors = false;
                    let checkGroups = Object.entries(this.steps);
                    for(const step in checkGroups){
                        foundErrors = ((checkGroups[step].findIndex(x => x.errors == true)) != -1) ? true : foundErrors;
                    }
                    return foundErrors;
                },
                createdCollection(){
                    return this.$store.getters['ProductCollection/createdCollection']
                }
            },
            created(){
                console.log('created');
                this.getBuyTeamOptions();
                this.getBuyerOptions();
                this.getVendorOptions();
                this.getVendorLocationOptions();
                this.getCurrencyOptions();
                this.getBrandOptions();
                this.getCategoryOptions();
                this.getSegmentOptions();
                this.getTenderOptions();
                this.getBoxOptions();
                this.getReceiptItems();
                this.getTenderTypes();
                this.loadValidationGroups();

            },
            mounted(){
                console.log('mounted');
                this.$store.dispatch('ProductCollection/addFormToStorage', {name: 'New Receipt', route: '/buy-tracker/receipt-create'})
            },
            methods: {
                getBoxOptions(){
                    this.$api.get('/api/faker', {}).then(response => {
                        this.boxOptions = [
                            {value: 1, label: 'box 1'},
                            {value: 2, label: 'box 2'},
                            {value: 3, label: 'box 3'},
                            {value: 4, label: 'box 4'},
                        ]
                    });
                },
                getBuyTeamOptions() {
                    this.$api.get('/api/faker', {}).then(response => {
                        this.buyTeamOptions = [
                            {value: 1, label: 'buyteam 1'},
                            {value: 2, label: 'buyteam 2'}
                        ]
                    });
                },
                getBuyerOptions() {
                    this.$api.get('/api/faker', {}).then(response => {
                        this.buyerOptions = [
                            {value: 1, label: 'buyer 1'},
                            {value: 2, label: 'buyer 2'},
                            {value: 'Taka', label: 'Taka'}
                        ]
                    });
                },
                getVendorOptions() {
                    this.$api.get('/api/faker', {}).then(response => {
                        this.vendorOptions = [
                            {value: 1, label: 'vendor 1'},
                            {value: 2, label: 'vendor 2'},
                            {value: 'APRE', label: 'APRE'}
                        ]
                    });
                },
                getVendorLocationOptions() {
                    this.$api.get('/api/faker', {}).then(response => {
                        this.vendorLocationOptions = [
                            {value: 1, label: 'vendor location 1'},
                            {value: 2, label: 'vendor location 2'},
                            {value: 'Japan', label: 'Japan'}
                        ]
                    });
                },
                getCurrencyOptions() {
                    this.$api.get('/api/faker', {}).then(response => {
                        this.currencyOptions = [
                            {value: 1, label: 'Currency 1'},
                            {value: 2, label: 'Currency 2'},
                            {value: 3, label: 'Currency 3'},
                            {value: 4, label: 'Currency 4'}
                        ]
                    });
                },
                getBrandOptions() {
                    this.$api.get('/api/faker', {}).then(response => {
                        this.brandOptions = [
                            {value: 1, label: 'brand 1'},
                            {value: 2, label: 'brand 2'},
                            {value: 'Prada', label: 'Prada'}
                        ]
                    });
                },
                getCategoryOptions() {
                    this.$api.get('/api/faker', {}).then(response => {
                        this.categoryOptions = [
                            {value: 1, label: 'category 1'},
                            {value: 2, label: 'category 2'},
                            {value: 'Bags', label: 'Bags'}
                        ]
                    });
                },
                getSegmentOptions() {
                    this.$api.get('/api/faker', {}).then(response => {
                        this.segmentOptions = [
                            {value: 1, label: 'segment 1'},
                            {value: 2, label: 'segment 2'},
                            {value: 3, label: 'segment 3'},
                            {value: 4, label: 'segment 4'},
                            {value: 5, label: 'segment 5'}
                        ]
                    });
                },
                getTenderOptions() {
                    this.$api.get('/api/faker', {}).then(response => {
                        this.tenderOptions = [
                            {value: 1, label: 'tender type 1'},
                            {value: 2, label: 'tender type 2'},
                            {value: 3, label: 'tender type 3'},
                            {value: 4, label: 'tender type 4'},
                            {value: 5, label: 'tender type 5'}
                        ]
                    });
                },
                getReceiptItems() {
                    this.$api.get('/api/faker', {}).then(response => {
                        this.receiptItems = {
                            headers:['Brand', 'Category', 'Segment', 'Quantity'],
                            items: {
                                0: ['LV', 'bags','LV Bags', 153],
                                1: ['Chanel', 'bags','CC Bags', 30]
                            }
                        }
                    });
                },
                getTenderTypes() {
                    this.$api.get('/api/faker', {}).then(response => {
                        this.tenderTypes = {
                            headers:['Tender Type', 'Amount', 'Date Used'],
                            items: {
                                0: ['Credit Card *1234', '$50,000','11/11/2020'],
                                1: ['Gift Card *555', '$30,500','01/12/2021']
                            }
                        }
                    });
                },
                submitForm(){
                    this.$store.dispatch["BuyTracker/ReceiptCreate/submit"]
                },
                loadValidationGroups(){
                    this.validationGroups = (this.validationGroups == null) ? this.receiptValidationGroups : this.validationGroups;
                },
                updateNav({currentStepIdx, newStepIdx}){
                    let currStepRef = this.steps[Object.entries(this.steps).find(step => step[1].order == currentStepIdx)[0]];
                    let newStepRef = this.steps[Object.entries(this.steps).find(step => step[1].order == newStepIdx)[0]];
                    if(newStepRef.errors == true){
                        this.showErrors = true;
                    }
                    currStepRef.errors = 
                       (this.validationGroups[this.activeStepName].findIndex(x => x.valid == false) == -1) ? false : true;
                    currStepRef.active = false;
                    currStepRef.completed = (newStepIdx > currentStepIdx) ? true : false;
                    newStepRef.active = true;
                    this.activeStepIdx = newStepIdx;
                },
                updateStepValidation({field, status}){
                    this.validationGroups[this.activeStepName][this.validationGroups[this.activeStepName].findIndex(x => x.name == field)].valid = status;
                },
                findItem(e){
                    //QNB0PBHEPH006
                    console.log('finditem called');
                    console.log('finditem: '+ e.target.productSkuSearch.value);
                    this.$store.dispatch('BuyTracker/ReceiptCreate/fetchItem', e.target.productSkuSearch.value);
                    this.resetIdx++;
                },
                saveReceipt(value){
                    console.log('Saving - '+ value);  //TODO - Save Receipt
                },
                onFocus(e){
                    e.target.value = '';
                },
                addtoBox(value){
                    console.log('Adding to Box - '+ value); //TODO - Add To Box
                },
                addtoReceipt(value){
                    console.log('Adding Receipt - '+ value); //TODO - Add to Receipt
                },
                addTendertype(value){
                    console.log('Adding Tender Type - '+ value); //TODO - Add Tender Type
                },
            }
        }
</script>
